import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import logger from "redux-logger";

import rootReducer from "./reducers";

const initialState = {};

let middleware = [thunk];

// if (process?.env?.NODE_ENV === "development") middleware = [thunk, logger];

const componseEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  initialState,
  componseEnhancers(applyMiddleware(...middleware))
);

export default store;
